const valueOrFallback = (value, fallback) => value ?? fallback;

export const mapBankAccountFormContent = localization => ({
  title: valueOrFallback(localization?.paymentAccountDetails, 'Payment Account Details'),
  summaryTitle: valueOrFallback(localization?.paymentAccountDetails, 'Payment Account Details'),
  skip: localization?.skip,
  disclaimer: valueOrFallback(
    localization?.discalmer,
    'Add your bank details to start receiving your online payments.',
  ),
  bankName: valueOrFallback(localization?.bankName, 'Bank Name'),
  bankPlaceholder: valueOrFallback(localization?.bankName, 'Bank Name'),
  holderName: valueOrFallback(localization?.nameAsPerBankAccount, 'Name as per Bank Account'),
  firstName: valueOrFallback(localization?.firstName, 'First'),
  middleName: valueOrFallback(localization?.middleName, 'Middle'),
  lastName: valueOrFallback(localization?.lastName, 'Last'),
  ownershipType: valueOrFallback(localization?.selectAccountType, 'Select Account Type'),
  companyAccount: valueOrFallback(localization?.companyAccount, 'Company Account'),
  personalAccount: valueOrFallback(localization?.personalAccount, 'Personal Account'),
  accountNumber: valueOrFallback(localization?.accountNumber, 'Account Number'),
  iban: valueOrFallback(localization?.iban, 'IBAN'),
  swiftCode: valueOrFallback(localization?.swiftCode, 'Swift Code'),
  cancel: localization?.cancel,
  continue: valueOrFallback(
    localization?.confirmAndContinue ?? localization?.saveChanges,
    'Confirm & Continue',
  ),
  chooseBank: valueOrFallback(localization?.bankSelectModal?.title, 'Choose Your Bank'),
  searchBank: valueOrFallback(localization?.bankName, 'Bank Name'),
  close: valueOrFallback(localization?.bankSelectModal?.close, 'Close'),
  edit: localization?.edit,
  confirm: localization?.confirm,
  submitting: valueOrFallback(localization?.confirm, 'Confirm'),
  selectBankRequired: valueOrFallback(localization?.pleaseSelectBank, 'Please select a bank'),
  firstNameRequired: valueOrFallback(
    localization?.pleaseEnterFirstName,
    'Please enter the first name.',
  ),
  firstNameInvalid: valueOrFallback(
    localization?.invalidFirstName,
    'Invalid first name. English letters only.',
  ),
  middleNameInvalid: valueOrFallback(
    localization?.invalidMiddleName,
    'Invalid middle name. English letters only.',
  ),
  lastNameRequired: valueOrFallback(
    localization?.pleaseEnterLastName,
    'Please enter the last name.',
  ),
  lastNameInvalid: valueOrFallback(
    localization?.invalidLastName,
    'Invalid last name. English letters only.',
  ),
  ownershipRequired: valueOrFallback(
    localization?.pleaseSelectAccountType,
    'Please select an account type.',
  ),
  accountNumberRequired: valueOrFallback(
    localization?.pleaseEnterAccountNumber,
    'Please enter the account number.',
  ),
  ibanRequired: valueOrFallback(localization?.pleaseEnterIban, 'Please enter IBAN'),
  ibanInvalid: valueOrFallback(
    localization?.invalidIban,
    'Invalid IBAN. Please check and try again.',
  ),
  swiftCodeRequired: valueOrFallback(
    localization?.pleaseEnterSwiftCode,
    'Please enter the swift code.',
  ),
  swiftCodeInvalid: valueOrFallback(
    localization?.invalidSwiftCode,
    'Invalid SWIFT code. Use Egyptian format: 8 or 11 characters (e.g. AAAEEGC1).',
  ),
  submitError: '',
});

export const mapBankAccountSummaryContent = localization => ({
  summaryTitle: valueOrFallback(localization?.title, 'Payment Account Details'),
  bankName: valueOrFallback(localization?.bankName, 'Bank Name'),
  holderName: valueOrFallback(localization?.nameAsPerBankAccount, 'Name as per Bank Account'),
  ownershipType: valueOrFallback(localization?.accountType, 'Account Type'),
  personalAccount: valueOrFallback(localization?.personalAccount, 'Personal Account'),
  companyAccount: valueOrFallback(localization?.companyAccount, 'Company Account'),
  accountNumber: valueOrFallback(localization?.accountNumber, 'Account Number'),
  iban: valueOrFallback(localization?.iban, 'IBAN'),
  swiftCode: valueOrFallback(localization?.swiftCode, 'Swift Code'),
  currency: valueOrFallback(localization?.currency, 'Currency'),
  cancel: valueOrFallback(localization?.cancel, 'Cancel'),
  edit: valueOrFallback(localization?.edit, 'Edit Payment Account'),
});

export const mapEmptyBankAccountContent = localization => ({
  summaryTitle: localization?.header,
  emptyTitle: localization?.title,
  emptyDescription: localization?.description,
  addAccount: localization?.add,
});
